<template>
    <div class="m-3 py-3" :class="Variant" style="border-radius: 5%;">
        <div class="d-flex flex-column mx-5 my-2">
            <div v-for="(time, index) in timeLine" :key="time.text + index" class="d-flex">
                <div class="align-content-end w-50">
                    <div v-if="index != 0" class="rounded-pill border mx-auto border-gray-middle-dark p-1" :class="Periods[index - 1].Selected ? 'bg-secondary' : 'bg-white'" style="height: 2.7rem; width: 0.7rem" />
                    <div class="rounded-pill border mx-auto border-gray-middle-dark p-1 bg-white" style="height: 1rem; width: 1rem" />
                </div>
                <div class="d-flex align-content-end w-50">
                    <div v-if="indexPeriod === index" 
                        class="align-content-end text-center">
                        <b-form-input v-model="tempDate" @keydown.enter="closeInput()" autofocus button-only right locale="fr" type="date" ref="focusDate" />
                    </div>
                    <div v-else class="d-flex" @click.stop="WriteAction ? updateIndex(index) : ''">
                        <div class="px-1 align-content-end" style="width: max-content">{{ time.text }}</div>
                    </div>
                    <div v-if="WriteAction && (index === 0 || index === Periods.length)" :class="indexPeriod === index ? 'mb-2' : ''" role="button" class="align-content-end text-center w-100" @click.prevent="clearDate(index)">
                        <b-icon icon="eraser" />
                    </div>
                </div>
            </div>
        </div>
        <div class="my-4">
            <div class="d-flex">
                <div class="mx-auto">
                    <div class="d-flex" style="height: 3rem">
                        <b-icon icon="eraser" class="my-auto mx-2" style="height: 1rem; width: 1rem" />
                        <div class="my-auto" style="font-size: 0.6rem;">
                            {{ $t("DefaultValue") }}
                        </div>
                    </div>
                </div>
                <div class="mx-auto">
                    <div class="d-flex" style="height: 3rem">
                        <div class="rounded-pill border border-gray-middle-dark p-1 bg-white my-auto mx-2" style="height: 1rem; width: 1rem" />
                        <div class="my-auto" style="font-size: 0.6rem;">
                            {{ $t("PivotPoint") }}
                        </div>
                    </div>
                </div>
            </div>
             <div class="d-flex">
                <div class="mx-auto">
                    <div class="d-flex" style="height: 3rem">
                        <div class="rounded-pill border border-gray-middle-dark p-1 bg-secondary my-auto mx-2" style="height: 0.5rem; width: 2rem" />
                        <div class="my-auto" style="font-size: 0.6rem;">
                            {{ $t("SelectedPeriod") }}
                        </div>
                    </div>
                </div>
                <div class="mx-auto">
                    <div class="d-flex" style="height: 3rem">
                        <div class="rounded-pill border border-gray-middle-dark p-1 bg-white my-auto mx-2" style="height: 0.5rem; width: 2rem" />
                        <div class="my-auto" style="font-size: 0.6rem;">
                            {{ $t("OtherPeriods") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>                 
</template>

<script lang="ts">
    import { Prop, Vue, Watch } from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import Period from '@/types/Period';
    import AllocationUtils from './AllocationUtils';
    import locales from "../locales/Allocation.json";
    import moment from 'moment';
    import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
    import { BFormInput } from 'bootstrap-vue'

    @Component({
        components: {
            'hsc-menu-style-custom': HscMenuStyleCustom("secondary")
        },
        i18n: { messages: locales }
    })
    export default class AllocationTimeLine extends Vue {
        @Prop()
        public Periods!: Period[];

        @Prop()
        public Variant: string;

        @Prop({ default: () => -1})
        private Index!: number;

        @Prop({default: () => true})
        private WriteAction: boolean;

        private allocationUtils: AllocationUtils = {} as AllocationUtils;

        private timeLine: {text: string, value: Date}[] = [];
        private indexPeriod: number = -1;
        private tempDate: string = "";
        
        private getTimeline() : { text: string, value: Date }[]
        {
            let _timeline: {text: string, value: Date}[] = [];

            this.Periods.forEach((period, index) => {
                if(index === 0 && this.allocationUtils.IsNullDate(period.StartDate)){
                    _timeline.push({text: this.$t('Installation').toString(), value: null});
                } else _timeline.push( { text: moment(period.StartDate).format('DD/MM/yyyy'), value: period.StartDate } )
            })

            if(this.allocationUtils.IsNullDate(this.Periods[this.Periods.length - 1]?.EndDate)){
                _timeline.push( { text: this.$t('Today').toString(), value: null } );
            } else {
                _timeline.push( { text: moment(this.Periods[this.Periods.length - 1]?.EndDate).format('DD/MM/yyyy'), value: this.Periods[this.Periods.length - 1]?.EndDate});
            }

            return _timeline;
        }

        public closeInput() : void
        {
            this.updateDate(this.tempDate)
            this.indexPeriod = -1;
        }

        @Watch('indexPeriod')
        private generateTempDate() : void
        {
            if(this.indexPeriod !== -1){
                this.tempDate = moment(this.timeLine[this.indexPeriod].value).format('yyyy-MM-DD');

                this.$nextTick(() => {
                    let focusDateComponent: Vue = this.$refs.focusDate as Vue;
                    if (focusDateComponent && focusDateComponent[0])
                        (focusDateComponent[0] as HTMLInputElement).focus();
                })
            }
        }

        private updateIndex(index) : void 
        {
            if(this.indexPeriod !== -1 && this.indexPeriod !== index)
                this.updateDate(this.tempDate);

            this.indexPeriod = index;
        }

        private updateDate(val: string) : void 
        {
            if(this.indexPeriod !== -1){
                let _date: Date = new Date(val);
                let _valid: boolean = false;
                if(this.indexPeriod == 0 && _date.getTime() < new Date(this.timeLine[this.indexPeriod + 1].value).getTime() || this.indexPeriod == this.timeLine.length - 1 && _date.getTime() > new Date(this.timeLine[this.indexPeriod - 1].value).getTime()){
                    _valid = true;
                } else {
                    let _afterDate: number = this.timeLine[this.indexPeriod + 1]?.value != null ? new Date(this.timeLine[this.indexPeriod + 1].value).getTime() : new Date().getTime();

                    if((this.timeLine[this.indexPeriod - 1]?.value != null && _date.getTime() > new Date(this.timeLine[this.indexPeriod - 1]?.value).getTime() || this.timeLine[this.indexPeriod - 1]?.value == null) && _date.getTime() < _afterDate)
                        _valid = true;
                }

                if(_valid)
                    this.$emit("update-date", this.indexPeriod, new Date(new Date(_date).toISOString()));
                else 
                    this.$bvToast.toast(this.$t('SupOrSubDate').toString(), {
                        title: this.$t('UnValidDate').toString(),
                        autoHideDelay: 10000,
                        variant: "danger",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
            }
        }

        private clearDate(index) : void 
        {
            this.indexPeriod = -1;
            if(index == 0)
                this.$emit("update-date", index, null);
            else 
                this.$emit("update-date", index, null);
        }

        @Watch("Periods", { deep: true })
        private generateTimeLine(){
            this.timeLine = this.getTimeline();
        }

        created(){
            this.allocationUtils = new AllocationUtils(this.$i18n);
            this.timeLine = this.getTimeline();
        }

        mounted(){
            this.indexPeriod = JSON.parse(JSON.stringify(this.Index));
        }
    }

</script>

<style>
    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
        border-color: var(--Variant) !important;
        background-color: var(--Variant) !important;
    }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }
</style>